import { createStore } from "redux";
import { startTestState, returnTestGrade } from "./ilabx-grade-return";
// const cankao = {
//   id: 12,
//   username: "wuyunan",
//   email: "me@wynwhy.com",
//   groups: ["teacher"],
//   nickname: "吴煜楠",
//   role: "教师",
//   card_number: "1000000000"
// };
const defualtStore = {
  account: { id: null, username: "", groups: [], role: "确认中" },
  wenxianOptions: [],
  categoryOptions: []
};
const anonymous = { id: null, username: "", groups: [], role: "访客" };

const myreducer = (state = defualtStore, action) => {
  switch (action.type) {
    case "UPDATEAccount":
      return { ...state, account: action.account };
    case "LOGOUT":
      return { ...state, account: anonymous };
    case "UPDATEWenxianOptions":
      return { ...state, wenxianOptions: action.wenxianOptions };
    case "UPDATECategoryOptions":
      return { ...state, categoryOptions: action.categoryOptions };
    default:
      return defualtStore;
  }
};
const store = createStore(myreducer);

export default store;
